import * as Preact from "preact"
import prettyms from "pretty-ms"

import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"

import "@frog/source/views/dev/screens/TestDetailsScreen.view.less"

import tests from "@frog/source/tests/_.js" // TODO: lazy load this
import {acceptOmegastage} from "@frog/source/utility/Testrecord.js"

export default class TestDetailsScreen {
    render() {
        if(window?.frog.navigation?.testslug == undefined) {
            return
        }
        const test = tests.find((test) => test.slug == Navigation.state.testslug)
        if(test == undefined) throw "Could not find test " + Navigation.state.testslug
        return (
            <div class="TestDetailsScreen">
                <div class="Popup">
                    <div class="Header">
                        <TestOverview test={test}/>
                        <CopyComputedOmegastageButton test={test}/>
                    </div>
                </div>
            </div>
        )
    }
}

class TestOverview {
    render() {
        if(this.props.test == undefined) {
            return
        }
        return (
            <div class="TestOverview" onClick={this.onMouseOver}>
                <div class="Status" status={this.props.test.status}/>
                <div class="Slug">{this.props.test.slug}</div>
                <div class="Flex"/>
                <div class="Duration">{prettyms(this.props.test.duration || 0)}</div>
            </div>
        )
    }
}

class CopyComputedOmegastageButton {
    render() {
        if(this.props.test.snapshot == undefined) {
            return
        }
        return (
            <div class="CopyComputedButton" onClick={this.onClick}>
                Copy Computed Omegastage to Clipboard
            </div>
        )
    }
    onClick() {
        acceptOmegastage()
    }
}
